import React, { useCallback } from 'react';
import { Input } from 'antd';
import s from './s.module.less';
import { replaceLineBreak } from '../../util';

interface IProps {
    showCount?: boolean;
    maxLength?: number;
    placeholder?: string;
    value?: string;
    onChange?: (v: string) => void;
}

const AutoLineBreakTextArea = ({
    showCount = true,
    maxLength = 800,
    value = '',
    placeholder,
    onChange,
}: IProps) => {
    const handleTreatmentTextChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = e.target.value;

        if (typeof onChange === 'function') {
            onChange(text);
        }
    }, [onChange]);

    const handleTreatmentKeypress = useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter') {
            const newTreatmentText = replaceLineBreak(value);

            if (typeof onChange === 'function') {
                onChange(newTreatmentText);
            }
        }
    }, [onChange, value]);

    return (
        <Input.TextArea
            className={s.textarea}
            showCount={showCount}
            maxLength={maxLength}
            value={value}
            onChange={handleTreatmentTextChange}
            onKeyPress={handleTreatmentKeypress}
            placeholder={placeholder}
        />
    );
};

export default AutoLineBreakTextArea;
